import PropTypes from 'prop-types';
import React from 'react';
import FeedbackFooter from './feedbackFooter';
import { SUBMIT_ERROR_MESSAGE } from './feedbackCopy';

/**
 * Shared wrapper for the three category forms: submit handling, the error banner and the footer
 * live here so each form only declares its own fields.
 */
const FeedbackFormShell = ({
  category,
  onBack,
  onSubmit,
  isSubmitDisabled,
  isSubmitting,
  hasSubmitError,
  children
}) => /*#__PURE__*/React.createElement("form", {
  className: "t-feedback-form",
  onSubmit: event => {
    event.preventDefault();
    onSubmit();
  }
}, children, hasSubmitError ? /*#__PURE__*/React.createElement("p", {
  className: "t-feedback-form__error",
  role: "alert"
}, SUBMIT_ERROR_MESSAGE) : null, /*#__PURE__*/React.createElement(FeedbackFooter, {
  onBack: onBack,
  submitLabel: category.submitLabel,
  submitColor: category.submitColor,
  isSubmitDisabled: isSubmitDisabled,
  isSubmitting: isSubmitting
}));
FeedbackFormShell.propTypes = {
  category: PropTypes.shape({
    submitLabel: PropTypes.string,
    submitColor: PropTypes.string
  }).isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitDisabled: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  hasSubmitError: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};
export default FeedbackFormShell;